import styled from 'styled-components/macro';
import * as colors from '../../common/colorConstants';

export const EmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: ${colors.lightGray10};
  padding: 40px 20px;
`;

export const EmptyStateText = styled.div`
  font-size: 14px;
  color: ${colors.lightGray5};
  text-align: center;
  line-height: 1.5;
`;
